import filter from '@/js/util/symbols/filter'
import propsTag from '@/js/util/props/propsTag'

// Borrowing this animation from tabs
import TabsTransition from '@/js/components/tabs/TabsTransition'

export default {
  inject: { filter },
  props: {
    ...propsTag,

    type: {
      type: String,
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },

    mode: {
      type: String,
      default: 'show',
      validatior: mode => [
        'if',
        'show',
      ].includes(mode),
    },
  },

  computed: {
    filtered() {
      return this.filter.checked.map(({ type }) => type)
    },
    evaluteMultipleActive() {
      return this.filtered.includes(this.type)
    },


    evaluteSingleActive() {
      const { activeCheckbox: { type } } = this.filter
      return type === '' || type === this.type
    },
    determineFilterType() {
      return this.multiple ? this.evaluteMultipleActive : this.evaluteSingleActive
    },
  },
  methods: {
    createChild(createElement) {
      const { determineFilterType } = this
      const elementData = {}

      if (this.mode === 'show') {
        elementData.directives = [{
          name: 'show',
          value: determineFilterType,
        }]
      }

      return this.show === 'show' || determineFilterType
        ? createElement(this.tag, elementData, this.$slots.default)
        : undefined
    },
  },
  render(createElement) {
    return createElement(TabsTransition, [this.createChild(createElement)])
  },
}



// WEBPACK FOOTER //
// ./src/js/components/BaseFilterResultsItem.js